<template>
  <el-dialog title="新建虚拟事件"
             append-to-body
             :visible.sync="dialogVisible"
             width="1200px"
             :before-close="handleClose">

    <div  v-loading="loading">
      <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="120px"
             class="ruleForm">
      <el-form-item label="虚拟事件名称:"
                    prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <el-form-item label="组合一般事件:"
                    >
        *一般事件之间是or的关系。即当任意一个事件触发时，视作该虚拟事件被触发
        <dynamicallyAddingSelectors ref="dynamicallyAddingSelectors" />
      </el-form-item>
    </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveConfig">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import dynamicallyAddingSelectors from './dynamicallyAddingSelectors';
import { virtual_event_save,get_virtual_event_detail,virtual_event_quote_check } from '@/api/bigData';

export default {
  components: {
    dynamicallyAddingSelectors
  },
  data () {
    return {
      dialogVisible: false,
      loading:false,
      ruleForm: {
        name: '',
        content:[]
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],

      }
    };
  },
 
  methods: {
    //获取详情
    getDetail (id) {
      this.$nextTick(()=>{
        console.log('id--',id)
      // 如果没有id,清空数据
      if(!id){
        this.ruleForm = {
          name: '',
          content:[]
        }
        this.$refs.dynamicallyAddingSelectors.content = []
        return
      }
      this.loading = true
      get_virtual_event_detail({id:id}).then(res=>{
        this.loading = false
        if(res.status==200){
          let data = JSON.parse(res.data)
          this.ruleForm.name = data.name
          this.ruleForm.id = data.id
          this.$refs.dynamicallyAddingSelectors.content = data.content ? data.content.virtual_event_list || [] : []
          console.log('获取详情--data-->>',data)
        }
      }).catch(()=>{  this.loading = false})
      })
    },
      // 保存配置
      saveConfig(){
        let params = {
          name:this.ruleForm.name,
          content:{virtual_event_list : this.$refs.dynamicallyAddingSelectors.content}
        }
        // 如果有id，修改，否则新增
        if(this.ruleForm.id){ params.id = this.ruleForm.id }
        // 需要校验
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$refs.dynamicallyAddingSelectors.validateDom(inerRes=>{
              if(inerRes){
               // 校验通过
               this.handleDialogClose(params)
              }
            })
          }
        });

    },
    // 确认弹框
    async handleDialogClose (params) {
      if(this.ruleForm.id){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });

      //删除前先调接口 virtual_event_quote_check 确认是编辑影响
    let res = await  virtual_event_quote_check({ id: this.ruleForm.id })
    loading.close();
    console.log('res-----',res)
  
    const h = this.$createElement;
    let view = [ h('div', { style: 'padding: 0 0 30px 0' }, `保存后会覆盖以下引用了该虚拟事件的报表配置，是否覆盖? `)]

    if(res.status==200){
      let list = JSON.parse(res.data) || []
      if(list.length){
        list.forEach(element => {
        view.push( h('div', { style: 'text-align: center' }, element.name))
      });
      }else{
        view.push( h('div', { style: 'text-align: center' }, '-暂无-'))
      }
    }
        this.$msgbox({
          title: '修改确认',
          message: h('p', null, view),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
            const res = await  virtual_event_save( params )
            if (res.status === 200) {
                this.$message({
                  message: `保存成功`,
                  type: 'success'
                });
                instance.confirmButtonLoading = false;
                done()
                this.$emit('getList')
                this.$refs.dynamicallyAddingSelectors.content = []
                this.ruleForm.name = ''
                this.ruleForm.id = ''
                this.dialogVisible=false                
            }else{
              instance.confirmButtonLoading = false;
              done()
            }
            } else {
              done()
            }
          }
        }).then(action => {
          console.log('action', action)
        }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        });
      });
      }else{
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        virtual_event_save(params).then(res=>{
          loading.close();
          if(res.status==200){
            this.$emit('getList')
            this.$refs.dynamicallyAddingSelectors.content = []
            this.ruleForm.name = ''
            this.ruleForm.id = ''
            this.dialogVisible=false
          }
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }).catch(()=>{  loading.close()})
      }
    },

  


    // 关闭弹窗
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.ruleForm {
  padding: 0 48px 24px;
}
</style>